// 路由守卫（权限判断）
import { useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { checkAuth } from '../../routes'
import { message } from 'antd';
function BeforeEnter(props) {
    // 守卫逻辑
    const [isNext, setIsNext] = useState(false);
    const navigate = useNavigate();
    // 获取地址函数
    const location = useLocation();
    // 路由守卫（权限判断）
    // 获取路由页面
    const route = checkAuth(location.pathname);
    // 消息提示
    useEffect(() => {
        // 根据路由条件判断
        if (route && route.auth) {
            const auth = localStorage.getItem("UserId");
            if (!auth) {
                message.error("请先登录！")
                setIsNext(false)
                navigate('http://uc.mairuizhe.cn/login?redirect=/index', {
                    replace: true,
                    state: { redirect: location.pathname, ...location.state }
                })
            } else {
                setIsNext(true)
            }
        } else {
            setIsNext(true)
        }
    })

    if (isNext) {
        return props.children;
    }
}
export default BeforeEnter;
